export type ClassValue = string | number | false | null | undefined;

export const cx = (...values: ClassValue[]): string =>
  values.filter(Boolean).join(' ');
